
export default function LocationsMap() {
  const locations = [
    {
      city: 'New York',
      address: '123 Broadway, New York, NY 10001',
      phone: '(212) 555-0123',
      hours: '24/7',
      type: 'Flagship Location'
    },
    {
      city: 'Los Angeles',
      address: '456 Sunset Blvd, Los Angeles, CA 90028',
      phone: '(323) 555-0456',
      hours: '6 AM - 11 PM',
      type: 'Airport Hub'
    },
    {
      city: 'Chicago',
      address: '789 Michigan Ave, Chicago, IL 60611',
      phone: '(312) 555-0789',
      hours: '24/7',
      type: 'Downtown Center'
    },
    {
      city: 'Miami',
      address: '321 Ocean Drive, Miami, FL 33139',
      phone: '(305) 555-0321',
      hours: '6 AM - 11 PM',
      type: 'Beach Location'
    },
    {
      city: 'Dallas',
      address: '654 Main Street, Dallas, TX 75201',
      phone: '(214) 555-0654',
      hours: '24/7',
      type: 'Business District'
    },
    {
      city: 'Seattle',
      address: '987 Pine Street, Seattle, WA 98101',
      phone: '(206) 555-0987',
      hours: '6 AM - 11 PM',
      type: 'Tech Hub'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Locations</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visit any of our 200+ locations nationwide. Find the nearest Car2Go rental center for convenient pickup and drop-off.
          </p>
        </div>

        {/* Interactive Map */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-12">
          <div className="h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387190.2799160891!2d-74.25987368715491!3d40.697670063539654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY!5e0!3m2!1sen!2sus!4v1647834726123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Car2Go Locations Map"
            ></iframe>
          </div>
        </div>

        {/* Location Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start justify-between mb-4">
                <h3 className="text-2xl font-bold text-gray-800">{location.city}</h3>
                <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
                  {location.type}
                </span>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-600 text-lg mr-3 mt-1"></i>
                  <div>
                    <div className="text-gray-800 font-medium">Address</div>
                    <div className="text-gray-600 text-sm">{location.address}</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-600 text-lg mr-3"></i>
                  <div>
                    <div className="text-gray-800 font-medium">Phone</div>
                    <div className="text-gray-600 text-sm">{location.phone}</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-time-line text-blue-600 text-lg mr-3"></i>
                  <div>
                    <div className="text-gray-800 font-medium">Hours</div>
                    <div className="text-gray-600 text-sm">{location.hours}</div>
                  </div>
                </div>
              </div>
              
              <div className="flex space-x-3 mt-6">
                <button className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer">
                  Get Directions
                </button>
                <button className="flex-1 border border-blue-600 text-blue-600 hover:bg-blue-50 font-semibold py-2 px-4 rounded-lg transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer">
                  Call Location
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-2xl p-8 shadow-lg mt-12">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">Can't Find a Location Near You?</h3>
            <p className="text-xl text-gray-600">
              We're constantly expanding our network. Contact us to learn about upcoming locations in your area.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-2-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">200+ Locations</h4>
              <p className="text-gray-600">Nationwide coverage in major cities and airports</p>
            </div>
            
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Flexible Hours</h4>
              <p className="text-gray-600">Many locations open 24/7 for your convenience</p>
            </div>
            
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">Local Support</h4>
              <p className="text-gray-600">Professional staff at every location to assist you</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-lg mb-12">
          <h3 className="text-3xl font-bold text-gray-800 mb-8 text-center">Our Main Office</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-blue-600 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">Headquarters</h4>
                  <p className="text-gray-600 leading-relaxed">
                    28 Hollis Rd<br />
                    East Brunswick, NJ 08816<br />
                    United States
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-phone-line text-blue-600 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">Phone</h4>
                  <p className="text-gray-600">+1 (732) 900-3478</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-mail-line text-blue-600 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">Email</h4>
                  <p className="text-gray-600">info@cartogo.co</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line text-blue-600 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">Business Hours</h4>
                  <p className="text-gray-600">
                    Monday - Sunday: 6:00 AM - 10:00 PM EST<br />
                    24/7 Emergency Support Available
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gray-100 rounded-xl p-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.5!2d-74.4!3d40.4!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI0JzAwLjAiTiA3NMKwMjQnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
